export const ALL_ITEMS = 'all'
export const DISHES = 'dishes'
export const MENU_TITLES = 'menuTitles'

export const MENU_VALIDATION_SCOPES = [
  { name: 'All items', value: ALL_ITEMS },
  { name: 'Dishes', value: DISHES },
  { name: 'Menu titles', value: MENU_TITLES },
]

export const MENU_VALIDATION_FIELDS = [
  'path',
  'name',
  'description',
  'price',
  'allergens',
  'diets',
  'miscInfo',
  'addons',
  'calories',
  'nutritions',
  'ingredients',
]
